var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Dependencies } from '~/core/decorator';
import { CaseInfoService } from '~/services/domain-service/case-info.service';
import { CaseInfoConfirmService } from "~/services/dataimp-service/case-info-confirm.service";
import CheckConfirm from "./check-confirm.vue";
var CaseBatchConfirm = /** @class */ (function (_super) {
    __extends(CaseBatchConfirm, _super);
    function CaseBatchConfirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.comfirmModel = {
            batchNumber: '',
            steplength: 0
        };
        _this.checkData = {};
        _this.dialog = false;
        _this.rules = {
            batchNumber: { required: true, message: "请选择批次号！" }
        };
        return _this;
    }
    CaseBatchConfirm.prototype.emitSuccess = function () {
        this.$message.success('案件信息确认后台正在进行,请前往待分配案件查看');
        this.emitClose();
    };
    CaseBatchConfirm.prototype.emitClose = function () {
        var form = this.$refs.form;
        form.resetFields();
    };
    /**
     * 选择批次号
     */
    CaseBatchConfirm.prototype.chooseBatchNumberConfirm = function () {
        var _this = this;
        var form = this.$refs.form;
        form.validate(function (v) {
            if (!v)
                return;
            _this.caseConfirm();
        });
    };
    CaseBatchConfirm.prototype.changeShopping = function (val) {
        var currentNumber = this.batchList.filter(function (x) { return x.batchNumber === val; })[0];
        if (currentNumber.productFlag === "YES" && currentNumber.personalFlag === "YES" && currentNumber.caseFlag === "YES") {
            this.comfirmModel.steplength = 3;
        }
        else if (currentNumber.personalFlag === "YES" && currentNumber.productFlag === "YES") {
            this.comfirmModel.steplength = 2;
        }
        else if (currentNumber.productFlag === "YES") {
            this.comfirmModel.steplength = 1;
        }
        else {
            this.comfirmModel.steplength = 0;
        }
    };
    /**
     * 案件确认选择批次号确认
     */
    CaseBatchConfirm.prototype.caseConfirm = function () {
        var _this = this;
        var _a = this.comfirmModel, flag = _a.steplength, batchNumber = _a.batchNumber;
        if (flag === 0) {
            this.caseInfoConfirmService.confirmProductInfo({ batchNumber: batchNumber }).subscribe(function (data) {
                _this.$message.success('产品信息确认成功');
                _this.comfirmModel.steplength = 1;
            });
        }
        else if (flag === 1) {
            this.caseInfoConfirmService.confirmPersonalInfo({ batchNumber: batchNumber }).subscribe(function (data) {
                _this.$message.success('客户信息确认成功');
                _this.comfirmModel.steplength = 2;
            });
        }
        else if (flag === 2) {
            var ss = {
                batchNumber: this.comfirmModel.batchNumber
            };
            this.caseInfoConfirmService.confirmCaseInfo(ss).subscribe(function (data) {
                if (data.messageModels !== null) {
                    _this.checkData = data;
                    _this.dialog = true;
                }
                else {
                    _this.emitSuccess();
                }
            });
        }
    };
    CaseBatchConfirm.prototype.success1 = function () {
        var _this = this;
        this.checkData.messageModels.forEach(function (val, idx, array) {
            _this.contractNumberList = __spreadArrays(val.contractNumberList);
        });
        var ss = {
            batchNumber: this.comfirmModel.batchNumber,
            contractNumberList: this.contractNumberList,
            status: this.checkData.status
        };
        this.caseInfoConfirmService.confirmCaseInfo(ss).subscribe(function (data) {
            _this.dialog = false;
            _this.emitSuccess();
        });
    };
    __decorate([
        Dependencies(CaseInfoService)
    ], CaseBatchConfirm.prototype, "caseInfoService", void 0);
    __decorate([
        Dependencies(CaseInfoConfirmService)
    ], CaseBatchConfirm.prototype, "caseInfoConfirmService", void 0);
    __decorate([
        Prop()
    ], CaseBatchConfirm.prototype, "batchList", void 0);
    __decorate([
        Emit("success")
    ], CaseBatchConfirm.prototype, "emitSuccess", null);
    __decorate([
        Emit("close")
    ], CaseBatchConfirm.prototype, "emitClose", null);
    CaseBatchConfirm = __decorate([
        Component({
            components: {
                CheckConfirm: CheckConfirm,
            }
        })
    ], CaseBatchConfirm);
    return CaseBatchConfirm;
}(Vue));
export default CaseBatchConfirm;
